import React from "react";
import PropTypes from "prop-types";
import LinkEl from "cape-mixer/lib/Link/Link";

import brandImage from "../../splash.jpg";
import {
  Wrapper,
  Tagline,
  Underline,
  Description,
  DescriptionWrapper,
  EventDate,
} from "./styles";

const Blurb = ({ description, tagline, eventDate }) => (
  <Wrapper>
    <div style={{ width: "100%", marginRight: "3rem", marginBottom: "3rem" }}>
      {/* <Tagline>
        <LinkEl routeId="studentList">
          <Underline>{tagline}</Underline>
        </LinkEl>
      </Tagline>
      <EventDate>{eventDate}</EventDate> */}
      <img src={brandImage} />
    </div>
    <DescriptionWrapper>
      {description.map((pText, index) => (
        // eslint-disable-next-line
        <Description key={index} dangerouslySetInnerHTML={{ __html: pText }} />
      ))}
    </DescriptionWrapper>
  </Wrapper>
);

Blurb.propTypes = {
  description: PropTypes.arrayOf(PropTypes.string),
  tagline: PropTypes.string,
  eventDate: PropTypes.string,
};
Blurb.defaultProps = {
  description: [
    // eslint-disable-next-line
    `<b>MICA GRAD SHOW 2020</b> showcases the culminating work of more than 150 of MICA's graduate students from the College's internationally renowned programs. This semester, due to the unprecedented world health pandemic, the College will showcase this groundbreaking work now and over the coming months in a new way: through online documentation.`,
    // eslint-disable-next-line
    `Join us for a season of innovative and inspiring art online that will feature the next generation of creative thinkers — artists, designers, filmmakers, educators and curators — as they demonstrate the power and possibility of contemporary art and design in a time where it is needed more than ever.`,
    // eslint-disable-next-line
    `We continue to explore and look forward to future opportunities for the public to connect with the MFA and MA work of the Class of 2020.`,
  ],
  tagline: "Meet the next generation of creative thinkers.",
  eventDate: "Spring / Summer 2020",
};

export default Blurb;



// WEBPACK FOOTER //
// ./src/components/Blurb/Blurb.jsx